import { useCallback, useState } from "react";

/** Bottom edge (px) of the active nav chrome: legacy `#header` or the side-nav `#top-bar`. */
export const useNavChromeBottom = () => {
	const [topOffset, setTopOffset] = useState<number | null>(null);

	const measureRef = useCallback((node: HTMLDivElement | null) => {
		if (node) {
			requestAnimationFrame(() => {
				const chrome = document.getElementById("header") ?? document.getElementById("top-bar");
				setTopOffset(chrome ? chrome.getBoundingClientRect().bottom : 64);
			});
		}
	}, []);

	return { topOffset, measureRef };
};
